function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: ".5",
  width: "33",
  height: "23",
  rx: "3.5",
  fill: "#fff",
  stroke: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.179 16.83a6.802 6.802 0 01-4.398 1.6c-3.745 0-6.781-3-6.781-6.7s3.036-6.7 6.78-6.7c1.679 0 3.215.602 4.399 1.6a6.802 6.802 0 014.398-1.6c3.745 0 6.781 3 6.781 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 01-4.399-1.6z",
  fill: "#ED0006"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.179 16.83a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.802 6.802 0 014.398-1.6c3.745 0 6.78 3 6.78 6.7s-3.035 6.7-6.78 6.7a6.802 6.802 0 01-4.398-1.6z",
  fill: "#F9A000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.179 16.83a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 00-2.382 5.1c0 2.042.924 3.87 2.382 5.1z",
  fill: "#FF5E00"
})));